import { tw } from '@x7web/tcom-ui'
import merge from 'lodash-es/merge'

export default merge({}, tw, {})
